<template>
  <v-card class="text-xs-center">
    <setStoreTable/>
  </v-card>
</template>

<script>

import setStoreTable from "@/components/back-office/SetApp/Store/SetStoreTable";
export default {
  components: {
    setStoreTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "App setting",
        disabled: true
      },
      {
        text: "Set store",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
